import type { FetchShipmentCategoriesQuery } from '@/features/shipment-categories/api'
import type { ShipmentCategoriesSearch } from '@/routes/_protected/$tenantKey/settings/shipment-categories/-models/shipment-categories-search'

export function buildFetchShipmentCategoriesQuery(
  tenantKey: string,
  deps: ShipmentCategoriesSearch
): FetchShipmentCategoriesQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
